<template>
  <main v-loading.fullscreen.lock="loading">
    <el-image class="banner" :src="HomeBanner" fit="cover" />
    <div class="container">
      <div class="switch-tab">
        <div class="tab-bar" :class="{ right: activeIndex === 1 }" />
        <div class="tab-item" :data-active="activeIndex === 0" @click="activeIndex = 0">学校</div>
        <div class="tab-item" :data-active="activeIndex === 1" @click="activeIndex = 1">日期</div>
      </div>
      <div v-if="activeIndex === 0" class="school-container">
        <el-input v-model="keywords" placeholder="请输入学校名称" type="search" suffix-icon="el-icon-search" @change="getSchoolList" />
        <div class="school-list">
          <SchoolBox v-for="item in schoolList" :key="item.id" :school-data="item" />
        </div>
      </div>
      <div v-if="activeIndex === 1" class="live-container">
        <div class="filter-area">
          <div class="filters">
            <div class="custom-select" @click="selectStatus">
              <span v-if="searchConditions.status === 0">直播状态</span>
              <span v-else>{{ statusList.find(item => item.id === searchConditions.status).name }}</span>
              <i class="el-icon-caret-bottom" />
            </div>
            <div class="custom-select" @click="showCalender = true">
              <span v-if="!searchConditions.date">直播时间</span>
              <span v-else>{{ searchConditions.date }}</span>
              <i class="el-icon-caret-bottom" />
            </div>
            <div v-if="searchConditions.status || searchConditions.date" class="clear-btn" @click="clearFilter">
              <i class="el-icon-close" />
              <span>清空筛选</span>
            </div>
          </div>
          <span class="live-count">共{{ liveList.length }}场直播</span>
        </div>
        <div class="live-list">
          <ListCard v-for="item in liveList" :key="item.id" :card-data="item" />
        </div>
      </div>
    </div>
    <calendar
      v-if="showCalender"
      ref="vCalendar"
      :show.sync="showCalender"
      mode="single"
      :default-date="searchConditions.date"
      :day-click="checkSelectDate"
      @change="onDateChange"
    />
    <CustomSelect
      v-if="showSelect"
      :options="statusList"
      :value="searchConditions.status"
      @confirm="handleConfirm"
      @cancel="showSelect = false"
    />
  </main>
</template>

<script>
import wx from 'weixin-js-sdk';
import { jsdkSignature, getSchoolList, getLiveList } from '@/api/customer';
import SchoolBox from './components/SchoolBox';
import CustomSelect from './components/CustomSelect';
import ListCard from '../components/ListCard';
import HomeBanner from '@/assets/images/backgrounds/broadcast/home-banner.webp'
export default {
  components: {
    SchoolBox,
    CustomSelect,
    ListCard
  },
  data() {
    return {
      HomeBanner,
      loading: false,
      activeIndex: 0,
      showSelect: false,
      showCalender: false,
      keywords: '',
      searchConditions: {
        status: 0,
        date: ''
      },
      statusList: [
        {
          id: 0,
          name: '全部',
        },
        {
          id: 2,
          name: '未开始',
        },
        {
          id: 3,
          name: '直播中',
        },
        {
          id: 1,
          name: '已结束',
        },
      ],
      value: 0,
      schoolList: [],
      liveList: []
    }
  },
  watch: {
    searchConditions: {
      handler() {
        this.getLiveList();
      },
      deep: true
    }
  },
  async mounted() {
    this.getSchoolList();
    this.getLiveList();

    // 微信订阅-分享
    if (this.isWechat()) {
      const { data: wxData } = await jsdkSignature({ url: location.href });
      wx.config({
        debug: false,
        appId: wxData.appId,
        timestamp: wxData.timestamp,
        nonceStr: wxData.nonceStr,
        signature: wxData.signature,
        jsApiList: [ // 这里是需要用到的接口名称
          'checkJsApi', // 判断当前客户端版本是否支持指定JS接口
          'updateAppMessageShareData', // 分享
          'updateTimelineShareData', // 分享朋友圈
          'getLocation', // 获取位置
          'openLocation', // 打开位置
          'scanQRCode', // 扫一扫接口
          'chooseWXPay', // 微信支付
          'chooseImage', // 拍照或从手机相册中选图接口
          'previewImage', // 预览图片接口
          'uploadImage' // 上传图片
        ],
        openTagList: ["wx-open-subscribe"], // 必填，需要使用的JS接口列表
      });
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: '高招荟·研招君',
          desc: '业内专业直播平台',
          link: location.href,
          imgUrl: 'https://info.wqserver.com/uploads/images/logo.png',
          success: function() {
            // 设置成功
            console.log('分享至聊天窗口成功');
          },
          fail: function() {
            console.log('分享至聊天窗口失败');
          }
        });
        // 分享到朋友圈及分享到QQ空间
        wx.updateTimelineShareData({
          title: '高招荟·研招君',
          desc: '业内专业直播平台',
          link: location.href,
          imgUrl: 'https://info.wqserver.com/uploads/images/logo.png',
          success: function() {
            // 设置成功
            console.log('分享朋友圈成功');
          },
          fail: function() {
            console.log('分享朋友圈失败');
          }
        });
      });
    }
  },
  methods: {
    selectStatus() {
      this.showSelect = true;
    },
    handleConfirm(value) {
      this.searchConditions.status = value;
      this.showSelect = false;
    },
    selectDate() {
      this.showCalender = true;
    },
    clearFilter() {
      this.searchConditions = {
        status: 0,
        date: ''
      };
    },
    checkSelectDate(date) {
      const dateStr = date.format('YYYY-MM-DD');
      if (this.searchConditions.date === dateStr) {
        this.searchConditions.date = '';
        this.$refs.vCalendar.changeDateView();
        this.showCalender = false;
        return false;
      }
      return true;
    },
    onDateChange(date) {
      this.searchConditions.date = date.format('YYYY-MM-DD');
      this.showCalender = false;
    },

    async getSchoolList() {
      this.loading = true;
      const { statusCode, data } = await getSchoolList({
        keyword: this.keywords
      });
      if (statusCode === 0) {
        this.schoolList = data;
      }
      this.loading = false;
    },
    async getLiveList() {
      this.loading = true;
      const { statusCode, data } = await getLiveList({
        status: this.searchConditions.status || '',
        date: this.searchConditions.date
      });
      if (statusCode === 0) {
        this.liveList = data;
      }
      this.loading = false;
    },

    // 判断是否在微信
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/micromessenger/i) == 'micromessenger') { // eslint-disable-line
        return true;
      } else {
        return false;
      }
    },
  }
}
</script>

<style lang="less" scoped>
main {
  background-color: #F5F5F5;
  background-image: linear-gradient(to bottom, #1D6AE5, transparent 22rem);

  .banner {
    width: 100%;
    height: 15rem;
  }

  .container {
    margin-top: -1rem;
    width: 100%;
    background-color: #F5F5F5;
    padding: 0.75rem;
    border-radius: 0.875rem 0.875rem 0 0;

    .switch-tab {
      width: 100%;
      height: 3rem;
      margin-bottom: 1.25rem;
      border-radius: 1.5rem;
      background-color: #FFFFFF;
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      .tab-bar {
        width: 50%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 1.5rem;
        background-color: #1D6AE5;
        transition: all 0.3s ease-in-out;

        &.right {
          left: 50%;
        }
      }

      .tab-item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #A0A0A0;
        font-size: 1.125rem;

        &[data-active="true"] {
          color: #FFFFFF;
          font-weight: bold;
        }
      }
    }

    .school-container {
      width: 100%;

      ::v-deep {
        .el-input__inner {
          width: 100%;
          height: 3rem;
          border: 1px solid #2173EA;
          border-radius: 0.75rem;

          &:focus {
            box-shadow: 0 0 0.5rem #2173EA99;
          }
        }
      }

      .school-list {
        margin-top: 1rem;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        overflow: hidden;
        gap: 1rem;
      }
    }

    .live-container {
      width: 100%;

      .filter-area {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .filters {
          display: flex;
          align-items: center;
          gap: 0.5rem;

          .custom-select {
            width: fit-content;
            max-width: 6.5rem;
            overflow: hidden;
            height: 1.75rem;
            border-radius: 0.875rem;
            padding: 0 0.75rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            background-color: #2173EA;
            color: #FFFFFF;
            font-size: 0.875rem;

            span {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .clear-btn {
            font-size: 0.75rem;
            color: #FF4949;
          }
        }

        .live-count {
          color: #787878;
          font-size: 0.75rem;
        }
      }

      .live-list {
        margin-top: 1.5rem;
      }
    }
  }
}
</style>
